/* disable-eslint */

import React from 'react'

const HerokuSvg = () =>{
    return(
	<div style={{ "textAlign": "center", "display": "flex", "justifyContent": "center"}}>
		<svg width="100%" height="100%" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" fill="#000000">
			<g id="SVGRepo_bgCarrier" strokeWidth="0"/>
			<g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
			<g id="SVGRepo_iconCarrier"> 
				<circle id='herokuLogo' cx="512" cy="512" r="512" style={{"fill":"#fff"}}/> 
				<path id='kerokuText' d="M695.7 256H328.3c-25.6 0-46.1 20.5-46.1 46.1V722c0 25.6 20.5 46.1 46.1 46.1h367.4c25.6 0 46.1-20.5 46.1-46.1V302.1c0-25.6-20.5-46.1-46.1-46.1zm20.5 466c0 11.5-9 20.5-20.5 20.5H328.3c-11.5 0-20.5-9-20.5-20.5V302.1c0-11.5 9-20.5 20.5-20.5h367.4c11.5 0 20.5 9 20.5 20.5V722zm-318.8-30.8L455 640l-57.6-51.2v102.4zm207.4-207.3c-10.2-10.2-29.4-23-61.4-23-34.6 0-70.4 9-96 17.9v-146h-51.2v221.5l35.8-16.6s58.9-26.9 110.1-26.9c25.6 0 32 14.1 32 26.9v153.6h51.2V537.6c1.3-3.8 1.3-32-20.5-53.7zM537 416h51.2c23-26.9 34.6-53.8 38.4-83.2h-51.2c-5.1 29.4-17.9 56.3-38.4 83.2z" style={{"fill":"#000"}}/> </g>
		</svg>
	</div>
    )
}


export default HerokuSvg;




